export const OS_VENDOR = {
    APPLE: /(mac|iphone|ipad|ipod)/i,
    WINDOWS: /Windows (?:NT [\d.]+|Phone)/i,
    ANDROID: /Android/i,
}

//TODO This could be expaned upon with other types such as DEVICE_TYPE etc and make use of testUserAgent, to further refactor duplicated functionality in utils into one function